<template>
  <!-- The "why" after a quick check: re-show the word with its meaning and
       example so a miss ends in re-teaching, not just a red X. -->
  <div v-if="word" class="mt-3 bg-gray-50 rounded-lg p-3 text-sm text-left">
    <div class="flex items-center gap-2">
      <p class="font-semibold text-gray-900">{{ word.word_vietnamese }} — {{ word.word_english }}</p>
      <AudioButton v-if="word.audio_url" :src="word.audio_url" />
    </div>
    <p v-if="word.example_sentence_vn" class="text-gray-500 mt-1">{{ word.example_sentence_vn }}</p>
    <p v-if="word.example_sentence_en" class="text-gray-400">{{ word.example_sentence_en }}</p>
  </div>
</template>

<script setup>
import AudioButton from './AudioButton.vue'

defineProps({
  word: { type: Object, default: null },
})
</script>
